import Vue from "vue";
import Vuex from "vuex";
import endpoint from "../Commons/Services";
import moment from "moment-timezone";
import helper from "../Commons/Helper";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        action: 'not-content',
        modalCustomer: false,
        countries: [],
        sidebarOpen: 'sidebar-open',
        activeView: '',
        statusModal: false,
        loader: false,
        sidebarOpenMap: '',
        themeColor: 'default',
        sesion: helper.services._SESION,
        profile: helper.services._PROFILE,
        sigout: false,
        date: moment.parseZone().utc(true),
        query: "",
        reservations: helper.services._RESPONSE,
        reservation: null,
        customersOptions: [],
        driversOptions: [],
        reservationId: "",
        branch: "",
        duplicate: {
            service: null,
            reservation: null,
            vehicle: null,
            branch: null
        },
        change: false,
        old: "",
        current: "",
        settings: {
            logos: {
                negative_version: "",
                positive_version: "",
                icon_positive_version: "",
                icon_negative_version: ""
            },
            themes: {
                option: "",
                color: ""
            },
            advanced_settings: {
                distance_max: "",
                advanced_reservation: "",
                cancelation_policy: "",
                markup: {
                    type: "vat",
                    value: 0
                }
            },
            global_info: {
                timezone: "",
                time_format: "hh:mm A",
                date_format: "DD-MMM-YYYY",
                measurement_unit: "",
                currency: "",
                language: "",
            },
            status: false
        },
        typeSearch: "normal",
        drivers: [],
        driverId: "",
        filters: {
            driver: {
                available: false,
                busy: false,
            },
            category: {
                standard: false,
                business: false,
                luxury: false,
            },
        },
        isEdit: false
    },
    mutations: {
        setSettings: (state, settings) => {
            state.settings = settings;
        },
        setTypeSearch: (state, typeSearch) => {
            state.typeSearch = typeSearch;
        },
        setAction: (state, action) => {
            localStorage.setItem("dp-action", action)
            state.action = action
        },
        setModalCustomer: (state, modalCustomer) => {
            state.modalCustomer = modalCustomer
        },
        setCountries: (state, countries) => {
            state.countries = countries
        },
        setActiveView: (state, activeView) => {
            state.activeView = activeView
        },
        setsidebarOpen: (state, sidebarOpen) => {
            state.sidebarOpen = sidebarOpen
        },
        changeStatusModal: (state, statusModal) => {
            state.statusModal = statusModal
        },
        setLoader: (state, loader) => {
            state.loader = loader
        },
        setsidebarOpenMap: (state, sidebarOpenMap) => {
            state.sidebarOpenMap = sidebarOpenMap
        },
        setThemeColor: (state, ThemeColor) => {
            state.ThemeColor = ThemeColor
        },
        setSesion: (state, sesion) => {
            if (sesion.token !== "") {
                localStorage.setItem("dp-sesion", JSON.stringify(sesion));
                state.sesion = sesion;
            } else {
                localStorage.removeItem("dp-sesion");
                state.sesion = sesion;
            }
        },
        setSigOut: (state, sigout) => {
            state.sigout = sigout
        },
        setProfile: (state, profile) => {
            state.profile = profile
        },
        setDate: (state, date) => {
            localStorage.setItem("dp-date", JSON.stringify(date))
            state.date = date;
        },
        setQuery: (state, query) => {
            localStorage.setItem("dp-query", query)
            state.query = query;
        },
        setReservations: (state, reservations) => {
            state.reservations = reservations;
        },
        setReservation: (state, reservation) => {
            state.reservation = reservation;
        },
        setCustomers: (state, customersOptions) => {
            state.customersOptions = customersOptions;
        },
        setDriversOptions: (state, driversOptions) => {

            state.driversOptions = driversOptions;
        },
        setReservationId: (state, reservationId) => {
            localStorage.setItem("dp-reservationId", reservationId)
            state.reservationId = reservationId;
        },
        setBranch: (state, branch) => {
            localStorage.setItem("dp-branch", branch)
            state.branch = branch;
        },
        setDuplicateReservation: (state, duplicate) => {
            localStorage.setItem("dp-duplicate", JSON.stringify(duplicate));
            state.duplicate = duplicate;
        },
        setChange: (state, change) => {
            state.change = change
        },
        setOldReservation: (state, old) => {
            state.old = old;
        },
        setCurrentReservation: (state, current) => {
            state.current = current;
        },
        setDrivers: (state, drivers) => {
            state.drivers = drivers;
        },
        setDriverId: (state, driverId) => {
            localStorage.setItem("dp-driverId", driverId);
            state.driverId = driverId
        },
        setFilters: (state, filters) => {
            state.filters = filters
        },
        setChange: (state, isEdit) => {
            state.isEdit = isEdit
        }
    },
    actions: {
        getBranch: ({ commit, state }) => {
            state.branch = (localStorage.getItem("dp-branch") !== null) ? localStorage.getItem("dp-branch") : "";
        },
        getReservationId: ({ commit, state }) => {
            state.reservationId = (localStorage.getItem("dp-reservationId") !== null) ? localStorage.getItem("dp-reservationId") : "";
        },
        getDuplicateReservation: ({ commit, state }) => {
            state.duplicate = (localStorage.getItem("dp-duplicate") !== null) ? JSON.parse(localStorage.getItem("dp-duplicate")) : null;
        },
        getReservation: ({ commit, state }, _id) => {
            try {
                let sesion = state.sesion;
                endpoint.reservations.services.getOneReservation(_id, sesion.token).then((response) => {
                    let result = response.data;
                    if (result.status) {
                        state.reservation = result.data;
                    } else {
                        state.reservation = null;
                    }
                }).catch((error) => {
                    state.reservation = null;
                    let auth = helper.services.unauthorizedAction(error);
                    if (auth) {
                        commit("setSigOut", true);
                    }
                })
            } catch (error) {
                state.reservation = null;
            }

        },
        getAction: ({ commit, state }) => {
            state.action = (localStorage.getItem("dp-action") !== null) ? localStorage.getItem("dp-action") : "not-content";
        },
        getQuery: ({ commit, state }) => {
            state.query = (localStorage.getItem("dp-query") !== null) ? localStorage.getItem("dp-query") : "";;
        },
        getDate: ({ commit, state }) => {
            state.date = (localStorage.getItem("dp-date") !== null && localStorage.getItem("dp-date") !== "null") ? moment.parseZone(JSON.parse(localStorage.getItem("dp-date"))).utc(true) : moment.parseZone().utc(true);
        },
        getSesion: ({ commit, state }) => {
            let sesion = (localStorage.getItem("dp-sesion") !== null) ? JSON.parse(localStorage.getItem("dp-sesion")) : state.sesion;
            state.sesion = sesion;
        },
        getCountries: ({ commit, state }) => {
            try {
                endpoint.countries.services.getCountries().then((response) => {
                    if (response.data.code === 200) {
                        state.countries = response.data.data
                    } else {
                        state.countries = [];
                    }
                }).catch((err) => {
                    state.countries = [];
                })
            } catch (error) {
                state.countries = [];
            }
        },
        getProfile: async ({ commit, state }) => {
            try {
                let sesion = state.sesion;
                let { data } = await endpoint.profile.services.getProfileUser(sesion.id, sesion.role, sesion.account_type.type, sesion.token);
                let result = data.data;
                if (data.status) {
                    if (sesion.account_type.type === "admin") {
                        state.profile = {
                            first_name: result.first_name,
                            last_name: result.last_name,
                            image: result.url_picture
                        }
                    } else if (sesion.account_type.type === "company") {
                        state.profile = {
                            first_name: result.account_first_name,
                            last_name: result.account_last_name,
                            image: result.url_picture
                        }
                    } else if (sesion.account_type.type === "supplier") {
                        let { data } = await endpoint.profile.services.getSettings(sesion.account_type.owner, sesion.token);
                        if (data.status) {
                            let settings = data.data;
                            commit("setSettings", {
                                logos: Object.assign({}, settings.logos),
                                themes: Object.assign({}, settings.themes),
                                advanced_settings: Object.assign({}, settings.advanced_settings),
                                global_info: Object.assign({}, settings.global_info),
                                status: true
                            })
                        }
                        state.profile = {
                            first_name: result.account_first_name,
                            last_name: result.account_last_name,
                            image: result.url_picture
                        }
                    } else {
                        let { data } = await endpoint.profile.services.getSettings(sesion.account_type.owner, sesion.token);
                        if (data.status) {
                            let settings = data.data;
                            commit("setSettings", {
                                logos: Object.assign({}, settings.logos),
                                themes: Object.assign({}, settings.themes),
                                advanced_settings: Object.assign({}, settings.advanced_settings),
                                global_info: Object.assign({}, settings.global_info),
                                status: true
                            })
                        }
                        state.profile = {
                            first_name: result.personal_info.first_name,
                            last_name: result.personal_info.last_name,
                            image: result.profile.image
                        }
                    }
                } else {
                    state.profile = helper.services._PROFILE;
                }
            } catch (error) {
                state.profile = helper.services._PROFILE;
                let auth = helper.services.unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        getReservations: ({ commit, state }, pagination) => {
            try {
                let sesion = state.sesion;
                commit("setTypeSearch", "normal");
                endpoint.reservations.services.getReservations(pagination, `${state.query}&date=${state.date.format()}&type=normal`, sesion.token).then((response) => {
                    let result = response.data;
                    if (result.status) {
                        state.reservations = result.data;
                    } else {
                        state.reservations = helper.services._RESPONSE;
                    }
                }).catch((error) => {
                    state.reservations = helper.services._RESPONSE;
                    let auth = helper.services.unauthorizedAction(error);
                    if (auth) {
                        commit("setSigOut", true);
                    }
                })
            } catch (error) {
                state.reservations = helper.services._RESPONSE;
            }
        },
        getReservationsFilter: ({ commit, state }, data) => {
            try {
                let sesion = state.sesion;
                commit("setTypeSearch", "filter");
                endpoint.reservations.services.getReservations(data.pagination, `${data.query}&date=${state.date.format()}&type=filter`, sesion.token).then((response) => {
                    let result = response.data;
                    if (result.status) {
                        state.reservations = result.data;
                    } else {
                        state.reservations = helper.services._RESPONSE;
                    }
                }).catch((error) => {
                    state.reservations = helper.services._RESPONSE;
                    let auth = helper.services.unauthorizedAction(error);
                    if (auth) {
                        commit("setSigOut", true);
                    }
                })
            } catch (error) {
                state.reservations = helper.services._RESPONSE;
            }
        },
        getCustomersOptions: ({ commit, state }) => {
            try {
                let sesion = state.sesion;
                endpoint.customers.services.getCustomersOptions(sesion.token).then((response) => {
                    let result = response.data;
                    if (result.status) {
                        state.customersOptions = result.data;
                    } else {
                        state.customersOptions = []
                    }
                }).catch((error) => {
                    state.customersOptions = [];
                    let auth = helper.services.unauthorizedAction(error);
                    if (auth) {
                        commit("setSigOut", true);
                    }
                })
            } catch (error) {
                state.customersOptions = [];
            }
        },
        getDriversOptions: ({ commit, state }, branchId) => {
            try {
                let sesion = state.sesion;
                endpoint.drivers.services.getDrivers(branchId, sesion.token).then((response) => {
                    let result = response.data;
                    if (result.status) {
                        let drivers = result.data;
                        if (branchId) {
                            state.driversOptions = drivers.filter(element => element.relationship.branch._id === branchId)
                        } else {
                            state.driversOptions = drivers;
                        }
                    } else {
                        state.driversOptions = []
                    }
                }).catch((error) => {
                    state.driversOptions = [];
                    let auth = helper.services.unauthorizedAction(error);
                    if (auth) {
                        commit("setSigOut", true);
                    }
                })
            } catch (error) {
                state.driversOptions = [];
            }
        },
        getDrivers: async ({ commit, state }, branchId) => {
            try {
                let sesion = state.sesion;
                let { data } = await endpoint.drivers.services.getDrivers(branchId, sesion.token);
                if (data.status) {
                    let drivers = data.data;
                    if (branchId) {
                        state.drivers = drivers.filter(element => element.relationship.branch._id === branchId)
                    } else {
                        state.drivers = drivers;
                    }
                } else {
                    state.drivers = []
                }
            } catch (error) {
                state.drivers = [];
                let auth = helper.services.unauthorizedAction(error);
                if (auth) {
                    commit("setSigOut", true);
                }
            }
        },
        getDriverId: async ({ commit, state }) => {
            let driverId = (localStorage.getItem("dp-driverId") !== null) ? localStorage.getItem("dp-driverId") : "";
            state.driverId = driverId;
        }
    },
    getters: {
        change: state => state.change,
        old: state => state.old,
        current: state => state.current,
        action: state => state.action,
        modalCustomer: state => state.modalCustomer,
        countries: state => state.countries,
        activeView: state => state.activeView,
        sidebarOpen: state => state.sidebarOpen,
        statusModal: state => state.statusModal,
        loader: state => state.loader,
        sidebarOpenMap: state => state.sidebarOpenMap,
        themeColor: state => state.themeColor,
        sesion: state => state.sesion,
        profile: state => state.profile,
        date: state => state.date,
        query: state => state.query,
        reservations: state => state.reservations,
        reservation: state => state.reservation,
        customersOptions: state => state.customersOptions,
        driversOptions: state => state.driversOptions,
        reservationId: state => state.reservationId,
        branch: state => state.branch,
        duplicate: state => state.duplicate,
        settings: state => state.settings,
        typeSearch: state => state.typeSearch,
        drivers: state => state.drivers,
        driverId: state => state.driverId,
        filters: state => state.filters,
        isEdit: state => state.isEdit,
    }
});